import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { SESSION_STORAGE_KEYS } from '../../constants';
import { BrandingService } from '../services/user/branding.service';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [],
  templateUrl: './error.component.html',
  styleUrl: './error.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ErrorComponent implements OnInit {
  logoPath: string = null as any;

  constructor(private brandingService: BrandingService) {}


  errorMessage: string = "You are not authorized to view this page. Please login in via the correct link";

  ngOnInit(): void {
    this.brandingService.getLogoPath().subscribe({
      next: (logo: string) => this.logoPath = logo,
      error: () => this.logoPath = './assets/alight_worklife_logo_black.svg'
    });

    if (sessionStorage.getItem(SESSION_STORAGE_KEYS.SAML_ERROR)) {
      this.errorMessage = "Not authorized. You dont have the required permissions. Check if you have access to crp-admin-content.";
      sessionStorage.removeItem(SESSION_STORAGE_KEYS.SAML_ERROR);
    }
  }
}
